export const Image = {
  logo: require('./images/logo.png'),
  successIcon: require('./images/icon-acknowledgement.png'),
  tokenIcon: require('./images/icon-token.png'),
  failIcon: require('./images/icon-fail.png'),
  emptyIcon: require('./images/icon-empty.png'),
  landingPopUp: require('./images/pop_up.jpg'),
  mobileLogo: require('./images/mobile_logo.png'),
  waltonLogo: require('./images/walton_logo.png'),
  jpOfferingModal: require('./images/JP_Offering_Modal.png'),
  jpOfferingBanner: require('./images/JP_Offering_Banner.png'),
  payNow: require('./images/paynow_logo.png'),
  paypal: require('./images/paypal_logo.png')
};
